import { scrollbarWidth } from './scrollbar-width'

export function tabPanels() {
	document.addEventListener('DOMContentLoaded', function () {
		scrollbarWidth()
		const containers = document.querySelectorAll('[data-tabpanels]')
		if (!containers.length) return

		containers.forEach(container => {
			const links = container.querySelectorAll('[data-tabpanels-link]')
			const sections = container.querySelectorAll('[data-tabpanels-content-item]')
			const images = container.querySelectorAll('[data-tabpanels-images] > *')
			const tabList = container.querySelector('[data-tabpanels-scroll-container]')

			let isScrolling = false
			let activeIndex = 0 // Always track current active

			function scrollTabIntoView(index) {
				const activeLink = links[index]
				if (!activeLink || !tabList) return

				const linkRect = activeLink.getBoundingClientRect()
				const containerRect = tabList.getBoundingClientRect()

				const linkLeft = linkRect.left - containerRect.left
				const linkRight = linkRect.right - containerRect.left
				const containerWidth = containerRect.width

				let scrollOffset = 0

				if (linkRight > containerWidth) {
					scrollOffset = linkRight - containerWidth
				} else if (linkLeft < 0) {
					scrollOffset = linkLeft
				}

				if (scrollOffset !== 0) {
					tabList.scrollTo({
						left: tabList.scrollLeft + scrollOffset,
						behavior: 'smooth',
					})
				}
			}

			function setActive(index) {
				// Ensure index is valid
				index = Math.max(0, Math.min(index, sections.length - 1))

				if (index === activeIndex) return

				activeIndex = index
				links.forEach((link, i) => link.classList.toggle('active', i === index))
				if (!isScrolling) {
					images.forEach((img, i) => img.classList.toggle('active', i === index))
				}
				scrollTabIntoView(index)
			}

			function checkScroll() {
				if (isScrolling) return

				const scrollTop = window.pageYOffset
				const triggerPoint = scrollTop + 600 // How far down we check

				// Start from current active and check if we should move
				for (let i = 0; i < sections.length; i++) {
					const section = sections[i]
					const sectionTop = section.getBoundingClientRect().top + scrollTop
					const sectionBottom = sectionTop + section.offsetHeight

					// If this section contains our trigger point, make it active
					if (sectionTop <= triggerPoint && sectionBottom > triggerPoint) {
						setActive(i)
						return
					}
				}

				// Fallback: if no section contains the trigger point
				// Find the section closest to the trigger point
				let bestIndex = activeIndex
				let bestDistance = Infinity

				sections.forEach((section, i) => {
					const sectionTop = section.getBoundingClientRect().top + scrollTop
					const distance = Math.abs(sectionTop - triggerPoint)
					if (distance < bestDistance) {
						bestDistance = distance
						bestIndex = i
					}
				})

				setActive(bestIndex)
			}

			// Throttled scroll
			let ticking = false
			function onScroll() {
				if (!ticking) {
					requestAnimationFrame(() => {
						checkScroll()
						ticking = false
					})
					ticking = true
				}
			}

			window.addEventListener('scroll', onScroll, { passive: true })

			// Click handling
			links.forEach((link, index) => {
				link.addEventListener('click', e => {
					e.preventDefault()

					const section = sections[index]
					if (!section) return

					isScrolling = true
					images.forEach((img, i) => img.classList.toggle('active', i === index))
					section.scrollIntoView({ behavior: 'smooth', block: 'start' })
					setActive(index)

					setTimeout(() => {
						isScrolling = false
					}, 1000)
				})
			})

			// First item is already active from PHP, just set our tracking variable
			activeIndex = 0
		})
	})
}
